import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-users-list-skeleton',
  templateUrl: './users-list-skeleton.component.html',
  styleUrls: ['./users-list-skeleton.component.css'],
  imports: [SkeletonComponent],
})
export class UsersListSkeletonComponent {
  readonly tableRows = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  readonly tableCols = [1, 2, 3, 4, 5, 6];
}
